import React, { Component } from "react";
import { RouteComponentProps } from "react-router";
import DefaultLayout from "layouts/Default";
import "./index.scss";
import ContentPageProvider from "components/content/ContentPageProvider";
import Banner from "../../components/banner";
import BookingEnquiryForm from "components/bookings/BookingEnquiryForm";
import TitleText from "../../components/titleText";
import HeroMedia from "../../components/heroImage";
import TextMedia from "../../components/textMedia";
import bg from "../../assets/img/steps/geo-2.svg";
// import SooksessStories from "components/sookStories";

export class ExperiencePage extends Component<RouteComponentProps> {
  render() {
    return (
      <DefaultLayout id="experience-page-showing?">
        <ContentPageProvider url={this.props.location.pathname}>
          <Banner />
          <BookingEnquiryForm />
          <TitleText code="titleText" />
          <HeroMedia code="heroMedia" />
          <TextMedia
            code="textMedia1"
            backgroundAsset={bg}
            backgroundAssetPosition={{ top: "-50%", left: "-20%" }}
            backgroundAssetSize="641px"
          />
          <TextMedia
            code="textMedia2"
            imageLeft={true}
            backgroundAsset={bg}
            backgroundAssetPosition={{ top: "10%", right: "-30%" }}
            backgroundAssetSize="720px"
          />
          <TextMedia code="textMedia3" imageLeft={false} />
          <TextMedia
            code="textMedia4"
            imageLeft={true}
            backgroundAsset={bg}
            backgroundAssetPosition={{ top: "-50%", left: "-20%" }}
            backgroundAssetSize="641px"
          />
          {/* <SooksessStories /> */}
        </ContentPageProvider>
      </DefaultLayout>
    );
  }
}

export default ExperiencePage;
